import React from 'react';
import { useParams } from 'react-router-dom';
import { RowLoader } from '../component-loader';
import { SelectRowInspector } from '../../molecules/select-row-inspector';

const SearchPage = () => {
  const { publisherId = '' } = useParams();
  return (
    <>
      <RowLoader />
      <SelectRowInspector publisherId={publisherId} />
    </>
  );
};

export default SearchPage;
